import React, { PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { actionCreators } from '../../state/modals-dux';
import authorized from '../../authorized';

import NavItemLink from './NavItemLink';
import LogoutModal from './LogoutModal';

const Layout = ({ route, children, user, showModal }) => (
  <section className={`layout route-${route}`}>
    {user &&
      <header className="container-fluid">
        <div className="user">
          <strong><span className="ti ti-user" />  {user.name}</strong>
          <a className="logout" onClick={() => showModal('LogoutModal')}>
            Logout
          </a>
          <LogoutModal />
        </div>
        <Link to="/" className="brand">CFT CMS</Link>
        <ul>
          <NavItemLink to="/pages">
            Active Pages
          </NavItemLink>
          <NavItemLink to="/files">
            Files
          </NavItemLink>
          <NavItemLink to="/tags">
            Tags
          </NavItemLink>
        </ul>
      </header>
    }
    <main>
      {children}
    </main>
  </section>
);

Layout.propTypes = {
  route: PropTypes.string,
  user: PropTypes.object,
  children: PropTypes.object
};

const mapState = state => ({ user: state.login.toJS().result });
const mapDispatch = dispatch => bindActionCreators(actionCreators, dispatch);
export default connect(mapState, mapDispatch)(Layout);



// WEBPACK FOOTER //
// ./src/components/ui/Layout.js